import { render, staticRenderFns } from "./app-form.vue?vue&type=template&id=6b1ab79c"
import script from "./app-form.vue?vue&type=script&lang=ts"
export * from "./app-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports